import { sortItems, useSelectedSort, useSelectSort } from 'src/features/filter-goods/model/sort'
import ComboBox from '@shared/ComboBox/ComboBox'
import { GoodsSortType } from 'src/features/filter-goods'
import * as S from './sort-list-desktop.styled'

const list = sortItems.map((x) => ({ ...x, text: x.content }))

export function SortListDesktop() {
    const selectedSort = useSelectedSort()
    const selectSort = useSelectSort()

    const clickSortItem = (sortType: GoodsSortType) => {
        selectSort(sortType)
    }

    return (
        <S.Container>
            <ComboBox
                items={list}
                defaultItem={selectedSort?.content}
                selectItemId={selectedSort.id}
                selectHandler={clickSortItem}
                placeholder={selectedSort?.content}
            />
        </S.Container>
    )
}
